import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function saveAttributeValue(app, dataToSave) {
  const { user = {}, data } = dataToSave;
  let attributeValueData = {
    doc_type: DocType.ATTRIBUTE_VALUE,
    active: util.toBoolean(data.active),
    name: util.toStringText(data.name),
    system_defined: util.toBoolean(data.system_defined)
  };
  return common.saveDoc(app, {
    source: data,
    doc: attributeValueData,
    user
  });
}

export function deleteAttributeValue(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.ATTRIBUTE_VALUE
  });
}

export function fetchAttributeValueById(app, params) {
  const { id } = params;
  const docType = DocType.ATTRIBUTE_VALUE;
  return common.getDoc(app, { id, docType });
}
